<template>
  <ReportWrapper>
    <template #actions>
      <div class="flex gap-x-2">
        <CfsDateField
          v-model="formModel.selectedDateRange"
          class="w-2/6 x-sm:w-full"
          placeholder="Select date range"
          range
        />
        <CfsSelect
          v-model="formModel.documentType"
          :return-object="false"
          :items="Object.values(MONTHLY_ORIGIN_REPORT_DOCUMENT_TYPE_OPTION)"
          placeholder="Document type"
        />
      </div>

      <v-btn
        color="primary"
        :loading="isLoading"
        :disabled="!formModel.selectedDateRange || !formModel.documentType"
        @click="downloadPdf"
      >
        <v-icon size="1rem" class="mr-1">mdi-tray-arrow-down</v-icon>
        <span>Download</span>
      </v-btn>
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import {
  DocumentTypes,
  MONTHLY_ORIGIN_REPORT_DOCUMENT_TYPE_OPTION,
  OutputTypes,
} from '@/constants/reports';
import date from '@/extensions/filters/date';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';
import useForm from '@/composables/forms/useForm';
import { useToast } from '@/composables/useToast';

export default defineComponent({
  name: 'MonthlyOriginReport',
  components: {
    ReportWrapper,
  },
  setup() {
    const toast = useToast();
    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();

    const { formModel } = useForm({
      selectedDateRange: null,
      documentType: null,
      outputType: OutputTypes.XLSX,
    });

    const downloadPdf = async () => {
      const { selectedDateRange, ...queries } = formModel.value;
      try {
        if (!formModel.value.documentType) {
          toast.info('Please select document type.');
          return;
        }

        const { data } = await downloadReport({
          ...queries,
          fromdate: selectedDateRange?.start,
          todate: selectedDateRange?.end,
        });

        if (!data) return;

        downloadFileByType(
          data,
          `${
            MONTHLY_ORIGIN_REPORT_DOCUMENT_TYPE_OPTION[
              formModel.value.documentType as DocumentTypes
            ]?.description
          } Report ${date(new Date())}`,
          OutputTypes.XLSX
        );
      } catch (e) {
        console.log(e);
      }
    };

    return { downloadPdf, isLoading, formModel, MONTHLY_ORIGIN_REPORT_DOCUMENT_TYPE_OPTION };
  },
});
</script>
